module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": _vm.href,
      "aria-controls": _vm.id,
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.title) + "\n  "), _c('i', {
    staticClass: "glyphicon glyphicon-remove",
    on: {
      "click": function($event) {
        return _vm.deleteShoppingList(_vm.id)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68fca22c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShoppingListTitleComponent.vue
// module id = 57
// module chunks = 1